<template>
    <div class="news">
        <div class="news-breadcrumb">
            <span><a @click="toYouleHome">首页</a></span>
            <span>{{newsInfo.title}}</span>
        </div>
        <div class="news-sidebar">
            <div class="news-sidebar__btn">
                <i class="el-icon-s-fold"  v-if="!showSidebar" @click="toggleSidebar"></i>
                <i class="el-icon-s-unfold" v-if="showSidebar" @click="toggleSidebar"></i>
            </div>
            <ul v-show="showSidebar" v-for="(item, key) in newsList" :key="key">
                <li :class="{active: item.id === newsInfo.id}"><a @click="changeNewsContent(item)">{{item.title}}</a></li>
            </ul>
        </div>
        <div class="news-main">
            <div class="center news-main__title">
                <h2>{{newsInfo.title}}</h2>
                <small class="small">{{newsInfo.created_at}}</small>
                <div class="splitline"></div>
                <div class="splitline"></div>
            </div>
            <div class="news-main__content">
                <div ref="content" v-html="newsInfo.content"></div>
            </div>
            <div>
                <el-backtop target=".page" :bottom="100" :right="100">
                </el-backtop>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNewsClassLists, getNewsInfo} from "../../assets/js/api/api";
    export default ({
        data () {
            return {
                newsInfo: {},
                showSidebar: true,
                btnText: '关闭导航',
                left: '-300px',
                newsList: []
            }
        },
        created () {
            this.getClass()
        },
        watch: {
          '$route' () {
              this.getClass();
              window.scrollTo(0,0)
          }
        },
        methods: {
            async getData (id) {
                let that = this;
                let res = await getNewsInfo({id: id});
                if (res.code === 1000){
                    that.newsInfo = res.data
                }
            },
            // 1稿费发放，2对外信息，3帮助说明，4关于我们，5作者相关
            getClass () {
                let that = this;
                let classid = this.$route.params.classid;
                let id = this.$route.params.id;
                getNewsClassLists({class: classid}).then((response) => {
                    if (response.code === 1000) {
                        that.newsList = response.data;
                        const dataid = response.data[0] ?  response.data[0].id : 0;
                        id = id === 'all' ? dataid : id;
                        this.getData(id)
                    }
                })
            },
            toggleSidebar () {
                this.showSidebar = !this.showSidebar;
            },
            toYouleHome () {
                window.open('www.iyoule.com', '_blank')
            },
            changeNewsContent(item) {
                this.$router.push({path: `/news/${item.class}/${item.id}`})
            }
        }
    })
</script>

<style lang="less">
    .news {
        display: grid;
        grid-template-columns: 220px minmax(600px, 900px);
        grid-template-rows: 50px 1fr;
        justify-content: center;
        grid-gap: 30px 45px;
        grid-template-areas:
            "bread bread "
            "sidebar content"
            "sidebar content";
        .news-breadcrumb {
            width: 100%;
            padding: 15px 0;
            font-size: 14px;
            border-bottom: 1px solid #cccccc;
            grid-area: bread;
            span + span:before {
                content: '>';
                padding: 0 4px;
            }
        }
        .news-sidebar {
            grid-area: sidebar;
            height: 100%;
            .news-sidebar__btn {
                display: none;
                i {
                    font-size: 2rem;
                    margin: 4px 0;
                }
            }
            ul {
                li {
                    height: 41px;
                    font-size: 15px;
                    border-bottom: 1px solid #cccccc;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    a {
                        margin: 10px 0;
                        display: inline-block;
                    }
                }
                .active {
                    background: #e8edfa;
                }
            }
        }
        .news-main {
            grid-area: content;
            background: #e8edfa;
            padding: 35px 50px 120px 50px;
            .news-main__title {
                margin-bottom: 2rem;
                h2 {
                    margin: 0 0 1rem 0!important;
                }
                small {
                    display: inline-block;
                    margin-bottom: 20px;
                }
                .splitline {
                    border-bottom: 1px solid #85888f;
                    padding-bottom: 2px;
                }
            }
            .news-main__content {
                div {
                    * {
                        line-height: 2;
                    }
                    img, table{
                        max-width: 100%;
                    }
                    h1, h2, h3, h4, h5, h6 {
                        margin: 0.4rem 0;
                    }
                }
            }
        }
        @media screen and (min-width: 1200px){
            .news-sidebar {
            }
        }
        @media screen and (min-width: 992px) and (max-width: 1200px){
            .news-sidebar {
            }
        }
        @media screen and (min-width: 768px) and (max-width: 992px){
        }
        @media screen and (max-width: 768px) {
            .news-sidebar .news-sidebar__btn {
                display: block;
            }
        }
    }
    @media screen and (max-width: 768px) {
        .news {
            display: block;
            .news-main {
                padding: 10px;
            }
        }
    }
</style>

